const e = () => ({
  dialog: {
    width: "100%",
    maxWidth: 440,
    borderRadius: 8
  },
  paperFullScreen: {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12
  }
}), d = e;
export {
  d as default
};
